import * as React from 'react';
import Svg, { SvgProps, Rect } from 'react-native-svg';

const TemplateIcon24 = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill={'none'}
    {...props}
  >
    <Rect
      width={6.458}
      height={6.458}
      x={3.799}
      y={3.799}
      fill={props.color ?? '#fff'}
      stroke={props.stroke ?? '#fff'}
      rx={0.5}
    />
    <Rect
      width={6.458}
      height={6.458}
      x={13.742}
      y={3.799}
      fill={props.color ?? '#fff'}
      stroke={props.stroke ?? '#fff'}
      rx={0.5}
    />
    <Rect
      width={6.458}
      height={6.458}
      x={13.742}
      y={13.742}
      fill={props.color ?? '#fff'}
      stroke={props.stroke ?? '#fff'}
      rx={0.5}
    />
    <Rect
      width={6.458}
      height={6.458}
      x={3.799}
      y={13.742}
      fill={props.color ?? '#fff'}
      stroke={props.stroke ?? '#fff'}
      rx={0.5}
    />
  </Svg>
);
export default TemplateIcon24;
